export interface Bulk {
    id: string;
    reference: string;
    status: BULK_STATUS;
    created_at: string;
    updated_at?: string;
    action_logs: ActionLog[];
    charges: BulkCharge[];
}

export interface ActionLog {
    id: string;
    created_at: string;
    status: ACTION_LOG_STATUS;
    type: ACTION_TYPE;
    items: ActionLogItem[];
}

export interface ActionLogItem {
    id: string;
    status: ACTION_LOG_ITEM_STATUS;
    charge: ActionLogItemCharge;
    transaction: ActionLogItemTransaction;
    error_summary?: ActionLogItemErrorSummary;
    charge_sources?: ActionLogItemChargeSources[];
}

export interface ActionLogItemCharge {
    id: string;
    type: ACTION_LOG_ITEM_CHARGE_TYPE;
    status: ACTION_LOG_ITEM_CHARGE_STATUS;
}

export interface ActionLogItemTransaction {
    id: string;
    type: ACTION_LOG_ITEM_TRANSACTION_TYPE;
    status: ACTION_LOG_ITEM_TRANSACTION_STATUS;
    fraud?: ActionLogItemFraud;
}

export interface ActionLogItemFraud {
    status: ACTION_LOG_ITEM_FRAUD_STATUS;
}

export interface ActionLogItemErrorSummary {
    message: string;
    code: string;
}

export interface ActionLogItemChargeSources {
    id: string;
    vault_token: string;
}

export interface BulkCharge {
    id: string;
    type: BULK_CHARGE_TYPE;
    vault_token?: string;
    attached_at: string;
}

export enum BULK_STATUS {
    NEW = 'new',
    IN_PROGRESS = 'inprogress',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export enum ACTION_LOG_STATUS {
    COMPLETED = 'completed',
    FAILED = 'failed',
    UNPROCESSABLE = 'unprocessable',
}

export enum ACTION_TYPE {
    FRAUD = 'fraud',
    REFUND = 'refund',
    CANCEL = 'cancel',
    CAPTURE = 'capture',
}

export enum ACTION_LOG_ITEM_STATUS {
    UNPROCESSABLE = 'unprocessable',
    COMPLETED = 'completed',
    FAILED = 'failed',
    PENDING = 'pending',
}

export enum ACTION_LOG_ITEM_CHARGE_TYPE {
    FINANCIAL = 'financial',
    FRAUD = 'fraud',
}

export enum ACTION_LOG_ITEM_CHARGE_STATUS {
    COMPLETE = 'complete',
    FAILED = 'failed',
    PENDING = 'pending',
    HELD = 'held',
    REQUESTED = 'requested',
    REFUND_REQUESTED = 'refund_requested',
    REFUNDED = 'refunded',
    IN_PROGRESS = 'inprogress',
    CANCELLED = 'cancelled',
    CANCEL_REQUESTED = 'cancel_requested',
    ARCHIVED = 'archived',
    CAPTURE_REQUESTED = 'capture_requested',
}

export enum ACTION_LOG_ITEM_TRANSACTION_TYPE {
    INITIALIZATION = 'initialization',
    SALE = 'sale',
    REFUND = 'refund',
    _3DS = '3ds',
    CANCEL = 'cancel',
    CAPTURE = 'capture',
    FRAUD = 'fraud',
    STANDALONE_3DS = 'standalone_3ds',
    PROCESS_STANDALONE_3DS = 'process_standalone_3ds',
    RESULT_STANDALONE_3DS = 'result_standalone_3ds',
    BALANCE = 'balance',
}

export enum ACTION_LOG_ITEM_TRANSACTION_STATUS {
    PENDING = 'pending',
    CANCEL_REQUESTED = 'cancel_requested',
    CAPTURE_REQUESTED = 'capture_requested',
    REQUESTED = 'requested',
    DECLINED = 'declined',
    APPROVED = 'approved',
    IN_PROGRESS = 'inprogres',
    COMPLETE = 'complete',
    FAILED = 'failed',
    CANCELLED = 'cancelled',
    AUTHENTICATION_PENDING = 'authentication_pending',
}

export enum ACTION_LOG_ITEM_FRAUD_STATUS {
    APPROVE = 'approve',
    FAILED = 'failed',
    REVIEW = 'review',
    REJECT = 'reject',
}

export enum BULK_CHARGE_TYPE {
    FINANCIAL = 'financial',
    FRAUD = 'fraud',
    _3DS = '3ds',
}

export interface BulkActionPayload {
    charges: { id: string }[];
}

export interface BulkFraudCheckPayload extends BulkActionPayload {
    service_id: string;
}

export const BULK_ACTION_HEADER_LABEL = {
    [ACTION_TYPE.REFUND]: 'Refund Request',
    [ACTION_TYPE.CAPTURE]: 'Capture',
    [ACTION_TYPE.CANCEL]: 'Cancel',
};

export const BULK_ACTION_BUTTON_LABEL = {
    [ACTION_TYPE.REFUND]: 'Refund',
    [ACTION_TYPE.CAPTURE]: 'Capture',
    [ACTION_TYPE.CANCEL]: 'Cancel',
};

export const VIEW_MODE_LOCAL_STORAGE_KEY = 'split_payments_view_mode';

export enum BULK_VIEW_MODE {
    BULK = 'bulk',
    ACTION = 'action',
}
